import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "dialog", "dialogInput"]
  static values = { commands: Array }

  connect() {
    // Debounce the search function to avoid excessive API calls
    // this.debouncedSearch = debounce(this.search, 300)
  }

  search() {
    // Use this code to search for records based on the controller search endpoint you setup. This will need to be tweaked to your needs.
    // const query = this.dialogInputTarget.value.toLowerCase()
    // Respond with Turbo Streams to update the results in real time. Your view needs a turbo_frame_tag with the id "results" or something similar.
    // Turbo.visit(`/admin/search?query=${encodeURIComponent(query)}`, {
    //   frame: "results",
    //   action: "update",
    //   headers: { Accept: "text/vnd.turbo-stream.html" },
    // })
  }

  handleKeyboardShortcut(event) {
    // Use a keyboard shortcut to open the command palette
    if ((event.metaKey || event.ctrlKey) && event.key === "k") {
      event.preventDefault()
      this.openCommandPalette()
    }
  }

  handleInput() {
    this.debouncedSearch()
  }

  // Handle command execution if necessary. Not currently used.
  executeCommand(event) {
    const action = event.currentTarget.dataset.command
    this[action]()
    this.closeCommandPalette()
  }

  openCommandPalette() {
    this.dialogTarget.classList.remove("hidden")
    this.dialogInputTarget.focus()
    this.dialogInputTarget.value = ""
  }

  closeCommandPalette() {
    this.dialogTarget.classList.add("hidden")
    this.dialogInputTarget.value = ""
    this.resultsTarget.innerHTML = ""
  }
}
